import { graphql } from '@/service/graphql'
import { gqlFetch } from '@/service/gql'
import { getAuth } from '@/auth/authRef'
import type { ResultOf } from 'gql.tada'
import { ctx } from '@/util/context'
import { logDebug } from '@amzn/vinyl-util'

export type LikeState = 'LIKE' | 'DISLIKE'

export const trackLikesContextFrag = graphql(`
    fragment trackLikesContext on Track @_unmask {
        id
        likesContext @include(if: $isAuthenticated) {
            liked
        }
    }
`)

export type TrackLikesContext = ResultOf<typeof trackLikesContextFrag>

const likeTrackQuery = graphql(
    `
        mutation setTrackLikeState(
            $likeState: String
            $trackId: String!
            $isAuthenticated: Boolean!
        ) {
            setTrackLikeState(likeState: $likeState, trackId: $trackId) {
                likeState
                track {
                    ...trackLikesContext
                }
            }
        }
    `,
    [trackLikesContextFrag]
)

export type LikeTrackQueryResult = ResultOf<typeof likeTrackQuery>

export interface TrackLikeOptions {
    readonly trackId: string
    readonly likeState: LikeState
}

const { target } = ctx('trackLikeService')

export async function setTrackLikeState(options: TrackLikeOptions): Promise<LikeTrackQueryResult> {
    logDebug(target, options)
    return gqlFetch(likeTrackQuery, {
        ...options,
        isAuthenticated: getAuth().isSignedIn(),
    })
}
